import { Module } from 'vuex';
import { IRootState, IMenuState } from '@types';

const store: Module<IMenuState, IRootState> = {
    state: {
        isMenuPopupOpen: false,
        isProfileDetailOpen: false,
        menuPopupContent: 'navigation',
        menuSection: '',
    },

    mutations: {
        openMenuPopup(state, data) {
            state.isMenuPopupOpen = true;
        },
        closeMenuPopup(state, data) {
            state.isMenuPopupOpen = false;
        },
        openProfileDetail(state, data) {
            state.isProfileDetailOpen = true;
        },
        closeProfileDetail(state, data) {
            state.isProfileDetailOpen = false;
        },
        toggleMenuPopup(state, data) {
            state.isMenuPopupOpen = !state.isMenuPopupOpen;
        },
        setMenuSection(state, data) {
            state.menuSection = data;
        },
    },

    getters: {
        getIsMenuPopupOpen: (state) => state.isMenuPopupOpen,
        getIsProfileDetailOpen: (state) => state.isProfileDetailOpen,
        getMenuSection: (state) => state.menuSection,

        getProfileButtons(state, getters) {
            return [
                {
                    key: 0,
                    to: { name: 'profile-share' }, // '/profile/share',
                    icon: 'share',
                    html: 'Share',
                    cls: 'share',
                    radius: 'circle',
                    size: 'big',
                    color: 'accent',
                    tpos: 'top',
                },
                {
                    key: 1,
                    to: { name: 'profile-edit' }, // '/profile/edit',
                    icon: 'manage_accounts',
                    html: '<b>My</b> Profile',
                    cls: 'profile',
                    radius: 'circle',
                    size: 'big',
                    color: 'accent',
                    tpos: 'top',
                },
                {
                    key: 2,
                    to: { name: 'profile-projects' }, // '/profile/edit',
                    icon: 'view_module',
                    html: '<b>My</b> Projects',
                    cls: 'project',
                    radius: 'circle',
                    size: 'big',
                    color: 'accent',
                },
                {
                    key: 3,
                    to: { name: 'profile-video' }, // '/profile/edit',
                    icon: 'smart_display',
                    html: '<b>My</b> video',
                    cls: 'video',
                    radius: 'circle',
                    size: 'big',
                    color: 'accent',
                },
                {
                    key: 4,
                    to: { name: 'profile-voice' }, // '/profile/portfolio-edit',
                    icon: 'volume_up',
                    html: '<b>My</b> voice',
                    cls: 'portfolio',
                    radius: 'circle',
                    size: 'big',
                    color: 'accent',
                },
                {
                    key: 5,
                    to: { name: 'profile-face' }, // '/profile/gallery/',
                    icon: 'camera_alt',
                    html: '<b>My</b> face',
                    cls: 'gallery',
                    radius: 'circle',
                    size: 'big',
                    color: 'accent',
                },
                {
                    key: 6,
                    to: { name: 'profile-contracts' }, // '/profile/contracts',
                    icon: 'article',
                    html: 'Contracts',
                    cls: 'contracts',
                    radius: 'circle',
                    size: 'big',
                    color: 'accent',
                },
            ].filter((item) => {
                return getters.getIsLoggedIn && !getters.getIsSetActorAccessToken;
            });
        },

        getPublicMenu(state, getters) {
            return [
                {
                    to: { name: 'home' },
                    icon: 'home',
                    text: 'Home',
                    size: 'small',
                },
                {
                    to: { name: 'voice-database' },
                    icon: 'keyboard_voice',
                    text: 'VOICE & FACE DATABASE',
                    size: 'small',
                },
                {
                    to: { name: 'music-zone' },
                    icon: 'queue_music',
                    text: 'MUSIC ZONE',
                    size: 'small',
                },
                {
                    to: { name: 'about' },
                    icon: 'portrait',
                    text: 'ABOUT',
                    size: 'small',
                },
            ];
        },

        getPrivateMenu(state, getters) {
            return [
                {
                    to: { name: 'profile-voice' }, // '/profile/portfolio-edit',
                    icon: 'volume_up',
                    text: 'My Voice',
                },
                {
                    to: { name: 'profile-face' }, // '/profile/gallery/',
                    icon: 'camera_alt',
                    text: 'My Face',
                },
                {
                    to: { name: 'profile-video' }, // '/profile/gallery/',
                    icon: 'smart_display',
                    text: 'My Video',
                },
                {
                    to: { name: 'profile-projects' }, // '/profile/gallery/',
                    icon: 'view_module',
                    text: 'My Projects',
                },
                {
                    to: { name: 'profile-edit' }, // '/profile/video/',
                    icon: 'manage_accounts',
                    text: 'My Profile',
                },
                {
                    to: { name: 'profile-contracts' }, // '/profile/contracts',
                    icon: 'article',
                    text: 'My Contracts',
                },
                {
                    to: { name: 'profile-share' }, // '/profile/share',
                    icon: 'share',
                    text: 'Share My Profile',
                },
            ];
        },
    },

    actions: {
        openMenuPopup({ commit, getters }) {
            commit('closeAllPopups');
            commit('openMenuPopup');
        },
        closeMenuPopup({ commit, getters }) {
            commit('closeMenuPopup');
        },
        openProfileDetail({ commit, getters }) {
            commit('openProfileDetail');
        },
        closeProfileDetail({ commit, getters }) {
            commit('closeProfileDetail');
        },
        toggleMenuPopup({ dispatch, commit, getters }) {
            // if(getters.getIsMenuPopupOpen)
            // 	return commit('closeMenuPopup');
            // dispatch('openMenuPopup');

            commit('toggleMenuPopup');
        },
    },
};

export default store;
